import {
    FaArrowRight,
    FaCodeBranch,
    FaExternalLinkAlt,
    FaGithub,
    FaLinkedin,
    FaStackOverflow,
} from 'react-icons/fa';
import './professional-presence.css';

const projects = [
    {
        name: 'GitHub Copilot Insights Dashboard',
        technology: 'TypeScript',
        href: 'https://github.com/amgdy/github-copilot-insights-dashboard',
    },
    {
        name: 'Copilot FinOps Automation',
        technology: 'JavaScript',
        href: 'https://github.com/amgdy/copilot-finops-automation',
    },
    {
        name: 'RFP Analyzer',
        technology: 'Python',
        href: 'https://github.com/amgdy/rfp-analyzer',
    },
];

export const ProfessionalPresence = () => (
    <section id="work" className="professional-presence" aria-labelledby="professional-presence-heading">
        <div className="professional-presence-inner">
            <div className="professional-presence-heading">
                <div>
                    <p>BUILD://SHARE</p>
                    <h2 id="professional-presence-heading">Open Source &amp; Community</h2>
                </div>
                <a
                    href="https://github.com/amgdy?tab=repositories"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="View all repositories on GitHub"
                >
                    All repositories <FaArrowRight aria-hidden="true" />
                </a>
            </div>

            <ul className="professional-projects" aria-label="Selected open-source projects">
                {projects.map((project) => (
                    <li key={project.name}>
                        <a
                            href={project.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={`View ${project.name} on GitHub`}
                        >
                            <FaGithub aria-hidden="true" />
                            <span>
                                <strong>{project.name}</strong>
                                <small><FaCodeBranch aria-hidden="true" /> {project.technology}</small>
                            </span>
                            <FaExternalLinkAlt aria-hidden="true" />
                        </a>
                    </li>
                ))}
            </ul>

            <div className="professional-channels">
                <a
                    href="https://www.linkedin.com/in/ahmedmagdy"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Writing and talks on LinkedIn"
                >
                    <FaLinkedin aria-hidden="true" />
                    <strong>LinkedIn</strong>
                    <FaArrowRight aria-hidden="true" />
                </a>
                <a
                    href="https://stackoverflow.com/users/70439/ahmed-magdy"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Developer community activity on Stack Overflow"
                >
                    <FaStackOverflow aria-hidden="true" />
                    <strong>Stack Overflow</strong>
                    <FaArrowRight aria-hidden="true" />
                </a>
            </div>
        </div>
    </section>
);

export const ProfessionalContact = () => (
    <section className="professional-contact-section" aria-labelledby="professional-contact-heading">
        <div className="professional-contact">
            <div>
                <p>CONNECT://NEXT</p>
                <h2 id="professional-contact-heading">Start a conversation</h2>
                <span>Architecture reviews, production AI applications on Azure, and modernization paths from design to delivery.</span>
            </div>
            <a href="https://www.linkedin.com/in/ahmedmagdy" target="_blank" rel="noreferrer">
                <FaLinkedin aria-hidden="true" /> Connect on LinkedIn
            </a>
        </div>
    </section>
);